// Timezone-safe calendar date utilities.
// All dates are handled as ISO strings 'YYYY-MM-DD' or UTC Date objects at 00:00 UTC.

export const toDate = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d));
};

export const toISO = (date) => date.toISOString().slice(0, 10);

export const addDays = (iso, n) => {
  const d = toDate(iso);
  d.setUTCDate(d.getUTCDate() + n);
  return toISO(d);
};

export const daysBetween = (isoA, isoB) =>
  Math.round((toDate(isoB) - toDate(isoA)) / 86400000);

export const todayISO = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const formatDMY = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}`;
};

// Parses "DD.MM.YYYY" -> "YYYY-MM-DD" or null if invalid
export const parseDMY = (str) => {
  if (!str) return null;
  const m = str.trim().match(/^(\d{1,2})[.\-/](\d{1,2})[.\-/](\d{4})$/);
  if (!m) return null;
  const d = parseInt(m[1], 10);
  const mo = parseInt(m[2], 10);
  const y = parseInt(m[3], 10);
  if (mo < 1 || mo > 12 || d < 1 || d > 31) return null;
  const iso = `${y}-${String(mo).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  // Round-trip check to catch invalid dates like 31.02.2024
  const dt = toDate(iso);
  if (
    dt.getUTCFullYear() !== y ||
    dt.getUTCMonth() !== mo - 1 ||
    dt.getUTCDate() !== d
  )
    return null;
  return iso;
};

// Convert JS Date (local) to ISO YYYY-MM-DD (using local Y/M/D)
export const dateToISO = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

// Convert ISO to a JS Date at local midnight (for date-pickers)
export const isoToDate = (iso) => {
  if (!iso) return undefined;
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const isBefore = (a, b) => a < b;
export const isAfter = (a, b) => a > b;
export const isSameOrBefore = (a, b) => a <= b;
export const isSameOrAfter = (a, b) => a >= b;
